import {
  AppEntry,
  CountryRevealLevel,
  RevealLevel,
} from "../../types/PublicListing";

export interface WizardFormData {
  companyName: string;
  revenueDisplay: RevealLevel;
  subscriptionsDisplay: RevealLevel;
  countryDisplay: CountryRevealLevel;
  websiteUrl: string;
  contactEmail: string;
  logoUrl: string;
  handle: string;
  appEntries: AppEntry[];
}

export const defaultFormData: WizardFormData = {
  companyName: "",
  revenueDisplay: "trendline",
  subscriptionsDisplay: "trendline",
  countryDisplay: "top3",
  websiteUrl: "",
  contactEmail: "",
  logoUrl: "",
  handle: "",
  appEntries: [],
};

export const HANDLE_REGEX = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;
